import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.scss"; // 特意移到这儿，因为放在上面覆盖不了antd的样式，为了设置body背景色
import "./elastic-apm";

ReactDOM.render(<App />, document.getElementById("root"));
